var _defs, _path, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.76 274.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -162.42,
    y1: 380.44,
    x2: -157.79,
    y2: 380.44,
    gradientTransform: "matrix(-23.41 0 0 23.41 -3690.23 -8855.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9b9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8594f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6184f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4678f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4678f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -179.2,
    y1: 391.98,
    x2: -174.58,
    y2: 391.98,
    gradientTransform: "matrix(0 42.45 42.45 0 -16596.09 7656.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8ab0f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#54cff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54cff3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -178.43,
    y1: 412.72,
    x2: -173.8,
    y2: 412.72,
    gradientTransform: "matrix(23.11 0 0 -23.11 4197.57 9688.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54cff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#54cff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#53c9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#50b8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4c9cf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4678f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4678f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -181.36,
    y1: 396.4,
    x2: -176.73,
    y2: 396.4,
    gradientTransform: "matrix(0 35.58 35.58 0 -13967.7 6452.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a3a1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8ab6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52e5ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(64.41 33.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.07 40.86c-4.37 3.27-6.55 5.92-8 8.73-7.6 15.32-2.38 29.84-.37 34.12s7 12.73 7 12.73L87.88 1.88z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(64.41 33.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.18 67.87c-2.85 6.41-5.77 13.72-6.48 20.7-.5 4.93-.8 10.79 0 22.85 1.48 18.58 10.9 35.27 24.18 44.85L87.81 198S50.37 144 18.75 90.31A54.46 54.46 0 0112.42 72a29.35 29.35 0 01.07-8.78c-.82 1.52-2.31 4.66-2.31 4.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(64.41 33.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.25 198l55.82-39c4.36-3.26 6.54-5.91 7.94-8.73 7.6-15.32 2.38-29.84.38-34.12s-7-12.73-7-12.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(64.41 33.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.38 109.58a54.27 54.27 0 016.33 18.31 29.54 29.54 0 01-.07 8.79c.82-1.52 2.31-4.66 2.31-4.66 2.85-6.41 5.77-13.73 6.47-20.71.5-4.93.8-10.79 0-22.85-1.42-18.56-10.9-35.26-24.18-44.84L94.32 1.87s37.44 54 69.06 107.71"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 151.7V50.31a.53.53 0 01.52-.52h64.42a.52.52 0 01.52.52v12.91a.52.52 0 01-.52.52h-49.4v29.93h42.06a.52.52 0 01.52.52V107a.52.52 0 01-.52.52h-42.06v30.79h49.4a.51.51 0 01.52.52v12.87a.51.51 0 01-.52.52h-64.41a.52.52 0 01-.52-.52m160.2.3l-47.13-71.83v71.49a.53.53 0 01-.52.52h-14.49a.52.52 0 01-.52-.52V50.37a.52.52 0 01.52-.52h13.43a.52.52 0 01.43.24l47.13 71.63V50.37a.53.53 0 01.52-.52h14.48a.52.52 0 01.52.52v101.29a.52.52 0 01-.52.52h-13.42a.53.53 0 01-.43-.24m61.85-19.41v4.81a98.69 98.69 0 0018.93 2.22 97.31 97.31 0 0018.71-2.2v-22.9L428.4 96a.51.51 0 01-.35-.49v-42.1a.47.47 0 01.33-.49A131.36 131.36 0 01462.12 48 133.16 133.16 0 01496 52.92a.47.47 0 01.33.49v15.91a.52.52 0 01-.52.52h-14.26a.53.53 0 01-.53-.52v-4.8a81.43 81.43 0 00-37.64 0l.06 21.64L496 104.55a.52.52 0 01.35.5v43.41a.47.47 0 01-.33.49 131.66 131.66 0 01-33.75 4.87 133.28 133.28 0 01-33.89-4.82.47.47 0 01-.33-.49v-15.97a.52.52 0 01.52-.52h14.24a.52.52 0 01.55.5",
    transform: "translate(64.41 33.68)",
    fill: "#828282"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-47.3 122.865 -7.535)",
    d: "M-6.75-9.12h117.89v116.57H-6.75z",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.51 116.75 72.515)",
    d: "M-32.76 53.42h156.24V207.8H-32.76z",
    fill: "url(#linear-gradient-2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-54.89 194.584 105.568)",
    d: "M70.73 94.35h118.4v112.76H70.73z",
    fill: "url(#linear-gradient-3)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-64.2 195.813 34.786)",
    d: "M57.61 1.72h158.33v135.13H57.61z",
    fill: "url(#linear-gradient-4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.9fee5130087f2d22475f4c46be81e805.svg";
export { ForwardRef as ReactComponent };